import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-loading-button',
  templateUrl: './loading-button.component.html',
  imports: [CommonModule, FormsModule, ReactiveFormsModule]
})
export class LoadingButtonComponent {
  @Input() text: string = 'Enviar';
  @Input() loading: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';

  get isDisabled(): boolean {
    return this.loading;
  }
}
